import React from 'react';
import { colors } from '../../constants/theme';

const Header = ({ 
  title = "Goleiro Raiz Academy", 
  rightContent, 
  showLogo = true 
}) => {
  return (
    <header className="text-white p-4 shadow-lg" style={{ backgroundColor: colors.primary }}>
      <div className="container mx-auto">
        <div className="flex flex-col gap-6 sm:flex-row sm:justify-between sm:items-center sm:gap-4">
          {/* Logo e Título */}
          <div className="flex items-center space-x-4">
            {showLogo && (
              <div className="bg-white p-2 rounded-lg shadow-sm">
                <img
                  src="logo.jpeg"
                  alt="Goleiro Raiz Academy"
                  className="h-12 w-auto"
                />
              </div>
            )}
            <div>
              <h1 className="text-xl sm:text-2xl font-bold leading-tight">{title}</h1>
            </div>
          </div>

          {/* Conteúdo da direita */}
          {rightContent}
        </div>
      </div>
    </header>
  );
};

export default Header;